import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import Grid from '@material-ui/core/Grid';


// Shows notification icon when no data is available.
export default class NoData extends React.Component {
    render() {
        return (
            <div style={{ padding: 50 }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item>
                        <Paper style={{ padding: 20 }}>

                            <NotificationImportant />
                            <Typography component={'span'} variant="body1" style={{ padding: 20 }}>
                                Tietoja ei ole saatavilla tai niitä ei ole
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}